import style from "./WebsiteReport.module.scss";
import className from "classnames/bind";
import {memo} from "react";
import {numberFormat} from "~/utils";
import {StatusLabel} from "~/components";
const cn = className.bind(style);

function WebsiteReportTotal({summary}) {

	if(!summary || !summary.service) return null;

	const services = Object.entries(summary.service).filter(([, service]) => service.total?.count > 0);

	return (
		<div className={cn('total-wrapper')}>
			{
				services.map(([serviceKey, service]) => (
					<div key={serviceKey} className={cn('summary-card')}>
						<div className={cn('summary-head')}>
							<StatusLabel small type={service.badge}>{service.name}</StatusLabel>
							<span className={cn('summary-head-count')}>{numberFormat(service.total?.count)} HĐ</span>
						</div>
						<div className={cn('row', 'row-head')}>
							<span className={cn('col-label')}>Loại hợp đồng</span>
							<span className={cn('col-count')}>SL</span>
							<span className={cn('col-amount')}>Giá trị</span>
						</div>
						{
							Object.entries(service.types).map(([typeKey, type]) => (
								<div key={typeKey} className={cn('row')}>
									<span className={cn('col-label')}>{type.name}</span>
									<span className={cn('col-count')}>{numberFormat(type.count)}</span>
									<span className={cn('col-amount')}>{numberFormat(type.amount)}</span>
								</div>
							))
						}
						<div className={cn('row', 'row-total')}>
							<span className={cn('col-label')}>Tổng</span>
							<span className={cn('col-count')}>{numberFormat(service.total?.count)}</span>
							<span className={cn('col-amount')}>{numberFormat(service.total?.amount)}</span>
						</div>
					</div>
				))
			}
			<div className={cn('summary-card', 'summary-grand')}>
				<div className={cn('row', 'row-total')}>
					<span className={cn('col-label')}>Tổng cộng</span>
					<span className={cn('col-count')}>{numberFormat(summary.total?.count)}</span>
					<span className={cn('col-amount')}>{numberFormat(summary.total?.amount)}</span>
				</div>
			</div>
		</div>
	)
}

export default memo(WebsiteReportTotal);
